module.exports = __webpack_public_path__ + "static/media/FM_EU_Costs_and_Associated_Charges_March_2025.53a01e3b.pdf";